/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { NavLink } from "react-router-dom";
import { css } from "@emotion/core";

import Button from "ui-modules/components/Form/Button";
import Image from "../../assets/images/seguin.png";
import background from "../../assets/images/earth-background.jpg";

const NoMatch: FC = () => {
  const styles = css`
    background-image: url(${background}) !important;
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    text-align: center;
    h3 {
      border-top: 1px solid #333;
      text-align: center;
      padding: 10px 0;
    }
  `;
  return (
    <div css={styles}>
      <div style={{ float: "right", margin: 100 }}>
        <img style={{ width: 300 }} src={Image} alt="Not Found" />
        <h3>صفحه مورد نظر شما یافت نشد!</h3>
        <NavLink to="/" style={{ textDecoration: "none" }}>
          <Button raised>صفحه اصلی</Button>
        </NavLink>
      </div>
    </div>
  );
};

export default NoMatch;
